
// NATIVE 


// INSTALLED 


// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import {  setFieldsForSelectRedux, setFieldsOrdenesServiciosRedux, setParametrosRedux, storeParameterRedux } from './ordenesDeServicioSlice';
// import { addRowTblPaginate, updateRowTblPaginate, updateStatusRowTblPaginate } from '../../commons/utils';
import { activeParameterService, createParameterService, 
        desactiveParameterService, getAllParameterByPaginateService, 
        getAllParametersService, getParameterDetailService, updateParameterDetailService } from '../../services';
import { asigarCampoOrdenesServicioService, createCampoOrdenesServicioService, getAllQuotationFieldService } from '../../services/ordenes-servicios.service';
import { setCategoriaCotizacionesRedux } from '../categoria-cotizacion';






// ************************************
// ************************************
// ************************************

// GESTIOn CAMPOS ORDENES DE SERVICIOS

// ************************************
// ************************************
// ************************************



export const getAllQuotationFieldRedux = (): any => {


    return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      
        const result = await getAllQuotationFieldService();
      
      dispatch( unCheckingPreload() );

      if( !result.ok ) return result;

      await dispatch( setFieldsOrdenesServiciosRedux(result.data.fieldOs) );
      await dispatch( setCategoriaCotizacionesRedux(result.data.categories) );
      await dispatch( setFieldsForSelectRedux(result.data.fieldsForSelect) );
      
      return result;



    }



}




export const storeCreateCamposOrdenesDeServicios = (dataOs: any, percentage:any): any => {


    return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      
     

    
      const dataOrdenesServicio = {
        name: dataOs.name,
        etiqueta: dataOs.etiqueta,
        tipoCampo: dataOs.tipoCampo,
        isRequired: dataOs.isRequired,
        opciones: Array.isArray(dataOs.opciones)
                ? dataOs.opciones
                : typeof dataOs.opciones === 'string'
                  ? dataOs.opciones.split(',').map( (op:any) => op.trim())
                  : [],
        category: dataOs.categoria.value,
        formula: dataOs.formula || "",
        dependencias: Array.isArray(dataOs.dependencias) && dataOs.dependencias.length > 0
          ? dataOs.dependencias.map((dep: any) => dep.label)
          : []

      };

      console.log(dataOrdenesServicio)
      const result = await  createCampoOrdenesServicioService(dataOrdenesServicio, percentage);

     
      if (result.ok) {
          await dispatch( setFieldsOrdenesServiciosRedux(result.data) );
      }
      
      
      
      dispatch( unCheckingPreload() );
      
      return result;



    }



}






export const storeCreateCamposTipoOrdenesServicios = (data: any, percentage:any): any => {

  

    return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );

      console.log(data)


      const result = await  asigarCampoOrdenesServicioService(data, percentage);

     
      if (result.ok) {
          await dispatch( setFieldsOrdenesServiciosRedux(result.data) );
      }
      
      
      
      dispatch( unCheckingPreload() );
      
      return result;



    }



}








export const getParametersStore = (): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      


      const result = await  getAllParametersService();



      ( result && result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );
     
      dispatch( unCheckingPreload() );

      if ( result.ok ) {

        // PARAMETROS 
          // await AsyncStorage.setItem(types.storage.parametrosStorage, JSON.stringify(result.data));
          await dispatch( setParametrosRedux(result.data) );

      }
      
      return result;
        
    }
}



export const getParameterByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      


      const result = await  getAllParameterByPaginateService(page);


      if ( result.ok ) {
          await dispatch( setParametrosRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}



export const  storeSetParameter = async( parameters: any ) => {


    return async( dispatch: any ) => { 

      await dispatch( setParametrosRedux(parameters) );

    
    }

}




export const storeCreateParameter = (parameter: any, percentage:any): any => {


    return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      

    
      const dataParameter = {
        parameterId:  parameter.parameterId,
        vista_lista:  0,
        redondeo:  0,
        llegadas_tarde:  parameter.llegadas_tarde,
        salidas_tarde:  parameter.salidas_tarde,
        salario_minimo:  parameter.salario_minimo,
        auxilio_transporte:  parameter.auxilio_transporte,
        interes_cesantias:  parameter.interes_cesantias,
        year:  parameter.year,
        cantidadHorasSemanales:  parameter.horasSemanales,
        cantidadHorasMensuales:  parameter.horasMensuales
      };




      const result = await  createParameterService(dataParameter, percentage);

     
      
      


      if ( result.ok ) {

        if ( Object.keys(result.data).length > 0  ) { 


          // const dataResult:any = await addRowTblPaginate(types.storage.parametrosStorage, result.data );

          if (result.ok) {

              await dispatch( setParametrosRedux(result.data) );
          }

        }
        
      }
      
      dispatch( unCheckingPreload() );
      
      return result;



    }



}




export const storeDesactiveParametro = (parametroId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );
      

      const result = await  desactiveParameterService(parametroId);

      
      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {

                                           // key storage      // id element         // status
          // const dataResult:any = await updateStatusRowTblPaginate(types.storage.parametrosStorage, parametroId, 0);

          if (result.ok) {

              await dispatch( setParametrosRedux(result.data) );
          }
          

      }

      return result;

  }

    
}




export const storeActiveParametro = (parametroId: string): any => {
  

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );
      

      const result = await  activeParameterService(parametroId);

      
      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
           
        // const dataResult:any = await updateStatusRowTblPaginate(types.storage.parametrosStorage, parametroId, 1);

        if (result.ok) {

            await dispatch( setParametrosRedux(result.data) );
        }

      }

      return result;

  }

    
}




export const storeDetailParameter = (parameterId: string): any => {
    

  return async( dispatch: any ) => { 


      await dispatch( checkingPreload() );
      
      

      const result = await  getParameterDetailService(parameterId);
    
      

      
      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {           

            const dataParameter = {
              id:  result.data.id,
              vista_lista:  result.data.vista_lista,
              redondeo:  result.data.redondeo,
              llegadas_tarde:  result.data.llegadas_tarde,
              salidas_tarde:  result.data.salidas_tarde,
              salario_minimo:  result.data.salario_minimo,
              auxilio_transporte:  result.data.auxilio_transporte,
              interes_cesantias:  result.data.interes_cesantias,
              year:  result.data.year
            }
            
            await dispatch( storeParameterRedux(dataParameter) );
      }


      return result;

  }

    
}




export const storeEditParameter = (parameter: any): any => {
    

  return async( dispatch: any ) => {       
      

      const dataParameter = {
        parameterId:  parameter.parameterId,
        vista_lista:  0,
        redondeo:  0,
        llegadas_tarde:  parameter.e_llegadas_tarde,
        salidas_tarde:  parameter.e_salidas_tarde,
        salario_minimo:  parameter.e_salario_minimo,
        auxilio_transporte:  parameter.e_auxilio_transporte,
        interes_cesantias:  parameter.e_interes_cesantias,
        year:  parameter.e_year
      }


      const result = await  updateParameterDetailService(dataParameter);
    
      
      if ( result.ok ) {

        if ( Object.keys(result.data).length > 0  ) { 

          // const dataResult:any = await updateRowTblPaginate(types.storage.parametrosStorage, result.data );

          if (result.ok) {

              await dispatch( setParametrosRedux(result.data) );
          }


        }

      }

      return result;

  }

    
}







